<template>
  <section
    class="flex flex-col w-80 shrink-0 h-full rounded-xl bg-n-solid-1 outline outline-1 outline-n-container"
  >
    <header class="flex items-center gap-2 px-3 py-2.5 border-b border-n-weak">
      <span class="size-2.5 rounded-full bg-n-alpha-2 animate-pulse" />
      <span class="h-3 w-24 rounded bg-n-alpha-2 animate-pulse" />
      <span class="h-4 w-6 ms-auto rounded-full bg-n-alpha-2 animate-pulse" />
    </header>
    <div class="flex flex-col gap-2 p-2">
      <div
        v-for="n in 3"
        :key="n"
        class="h-24 rounded-lg bg-n-alpha-2 animate-pulse"
        :style="{ animationDelay: `${n * 120}ms` }"
      />
    </div>
  </section>
</template>
